// extracted by mini-css-extract-plugin
export default {"pagingWrapper":"_Paging_pagingWrapper__b2U0T","pagingdetail":"_Paging_pagingdetail__hm0yE"};